import { render, staticRenderFns } from "./SetupConnectionModal.vue?vue&type=template&id=706dc4f1&scoped=true"
import script from "./SetupConnectionModal.vue?vue&type=script&lang=js"
export * from "./SetupConnectionModal.vue?vue&type=script&lang=js"
import style0 from "./SetupConnectionModal.vue?vue&type=style&index=0&id=706dc4f1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706dc4f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706dc4f1')) {
      api.createRecord('706dc4f1', component.options)
    } else {
      api.reload('706dc4f1', component.options)
    }
    module.hot.accept("./SetupConnectionModal.vue?vue&type=template&id=706dc4f1&scoped=true", function () {
      api.rerender('706dc4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/SetupConnectionModal.vue"
export default component.exports